export function normalizeDecimalInput(value) {
  if (typeof value !== "string") return value;

  const text = value.trim().replace(/\s|\u00a0/g, "");
  if (!text) return value;

  const lastComma = text.lastIndexOf(",");
  const lastDot = text.lastIndexOf(".");

  if (lastComma !== -1 && lastDot !== -1) {
    return lastComma > lastDot
      ? text.replace(/\./g, "").replace(",", ".")
      : text.replace(/,/g, "");
  }

  if (lastComma !== -1) return text.replace(",", ".");
  return text;
}

export function parseLocaleNumber(value, fallback = NaN) {
  if (value === null || value === undefined || value === "") return fallback;
  const parsed = Number(normalizeDecimalInput(value));
  return Number.isFinite(parsed) ? parsed : fallback;
}
